import { useEffect, useState } from "react";
import { useParams } from "react-router-dom"
import { Spinner } from "../components/common/Spinner";
import { getUserPublicProfile } from "../api/requests/profile";
import { ProfilePublicData } from "../api/requests/interfaces/UserProfileResponse";
import VerifiedUserOutlinedIcon from '@mui/icons-material/VerifiedUserOutlined';
import { Label } from "../components/form/Label";
import { differenceInDays, differenceInMonths, differenceInYears, format } from "date-fns";
import { et } from "date-fns/locale";
import { Tooltip } from "@mui/material";

export const ProfileViewPage = () => {
    const { profileId } = useParams();
    const [loading, setLoading] = useState(false);
    const [profileData, setProfileData] = useState<ProfilePublicData | undefined>(undefined);

    useEffect(() => {
        window.scrollTo(0, 0);
        if (profileId) {
            fetchProfiledata();
        }
    }, [profileId])

    const fetchProfiledata = async () => {
        setLoading(true);
        const res = await getUserPublicProfile(Number(profileId));
        setProfileData(res.data);
        setLoading(false);
    }

    const formatProfileCreatedTimeAgo = (dateCreated: Date) => {
        const diffInMonths = differenceInMonths(new Date(), dateCreated);
        const diffInYears = differenceInYears(new Date(), dateCreated);
        const diffInDays = differenceInDays(new Date(), dateCreated);
        if (diffInYears > 0) {
            if (diffInYears == 1) {
                return diffInYears.toString() + " aasta" 
            }
            return diffInYears.toString() + " aastat" 
        } else if (diffInMonths > 0) {
            if (diffInMonths == 1) {
                return diffInMonths.toString() + " kuu" 
            }
            return diffInMonths.toString() + " kuud" 
        } else {
            if (diffInDays == 1) {
                return diffInDays.toString() + " päev" 
            }
            return diffInDays.toString() + " päeva" 
        }
    }
    
    return (
        <div className="w-full h-full flex pt-[30px]">
            <div className="flex flex-col w-full">
                <div className="bg-primary h-[160px] w-full pl-5 pt-8 lg:pl-14 lg:pt-16 rounded-tl-lg rounded-tr-lg">
                    <div className={`flex rounded-[50%] relative bg-white shadow-main h-[160px] w-[160px] overflow-hidden justify-center translate-y-[0px] ${loading ? "skeleton_shine" : ""} cursor-pointer`} onClick={() => {}}>
                        {
                            (!loading && profileData) &&
                            <img className="object-cover" src={profileData.profilePicUrl} alt="Profile picture"  />
                        }
                    </div>
                </div>
                {
                    loading ?
                    <div className="w-full h-full flex justify-center mt-10">
                        <Spinner />
                    </div>
                    :
                    <>
                    {
                        profileData &&
                        <div className="ml-[20px] mt-8 lg:mt-0 pt-2 lg:ml-[250px]">
                            <div className="text-2xl font-bold flex justify-start items-center">
                                {profileData.name} {profileData.verified &&
                                    <Tooltip title={"Verifitseeritud kasutaja"} arrow>
                                        <VerifiedUserOutlinedIcon style={{width: "20px", height: "20px"}} className="text-primary font-bold ml-2"/>
                                    </Tooltip>
                                }
                            </div>
                            <div className="flex flex-row">
                                <Label value={"Konto loodud: "} />
                                <div className="text-sm pl-2">
                                    {
                                        profileData &&
                                        format(profileData.createdAt, 'dd. MMM yyyy', {locale: et})
                                    } ({formatProfileCreatedTimeAgo(profileData.createdAt)})
                                </div>
                            </div>
                        </div>
                    }
                    </>
                }
            </div>
        </div>
    )
}